exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.custom-time-period .btn-group {\n  height: unset !important;\n  margin: 0px !important;\n  padding: 0px !important;\n}\n.custom-time-period .dropdown-toggle {\n  padding: 0 !important;\n  background: none !important;\n  color: #172b43 !important;\n  font-size: 14px !important;\n  margin: 10px 0 0 0 !important;\n}\n.custom-time-period .dropdown-toggle .caret {\n    padding: 0px !important;\n    margin: 0px !important;\n    top: 17px !important;\n    right: 8px !important;\n    bottom: unset !important;\n    left: unset !important;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-2631a998","scoped":false,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?{"sourceMap":false}!./~/vue-loader/lib/selector.js?type=styles&index=1!./src/components/elements/ConfigBar.vue
// module id = 557
// module chunks = 0